// Helper function to recursively convert complex Firebase types to serializable primitives.
export const sanitizeData = (data: any): any => {
    if (data === null || typeof data !== 'object') {
        return data;
    }

    // Check for Firestore Timestamp and convert to ISO string
    if (data.toDate && typeof data.toDate === 'function') {
        return data.toDate().toISOString();
    }

    // Check for Firestore DocumentReference and convert to its path string.
    if (data.path && typeof data.path === 'string' && data.firestore) {
        return data.path;
    }
    
    // If it's an array, recursively convert its elements
    if (Array.isArray(data)) {
        return data.map(item => sanitizeData(item));
    }

    // If it's a plain object, recursively convert its properties
    const newObj: { [key: string]: any } = {};
    for (const key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
            newObj[key] = sanitizeData(data[key]);
        }
    }
    return newObj;
};